import { render, staticRenderFns } from "./UserRegLp.vue?vue&type=template&id=473a5ed9&scoped=true"
import script from "./UserRegLp.vue?vue&type=script&lang=js"
export * from "./UserRegLp.vue?vue&type=script&lang=js"
import style0 from "./UserRegLp.vue?vue&type=style&index=0&id=473a5ed9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a5ed9",
  null
  
)

export default component.exports